<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row class="ml-0 mt-3 mr-3">
          <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
            Inspection and Test Report Detail
          </v-chip>
          <v-spacer/>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="dis"
              :label="this.localForm.dis"
              :items="engineeringDiscipline"
              color="wplblue0"
              :disabled="this.disableEdit"
              prepend-icon="engineering"
              hint="enginering discipline"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="type"
              :label="this.localForm.type"
              :items="techReportType"
              :disabled="this.disableEdit"
              color="wplblue0"
              prepend-icon="settings_applications"
              hint="report type"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="theme"
              :label="this.localForm.theme"
              :items="techReportTheme"
              color="wplblue0"
              :disabled="this.disableEdit"
              prepend-icon="grid_view"
              hint="report theme"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="life"
              :label="this.localForm.life"
              :items="techReportLife"
              :disabled="this.disableEdit"
              color="wplblue0"
              prepend-icon="adjust"
              hint="system lifecyle"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2 mt-4">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.des"
            label="Technical Results Comments"
            :disabled="this.disableEdit"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="inspection and test results description"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import opsOptions from "@/data/options/mixins/opsOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
// import WorkRequestNew from "@/work/request/components/WorkRequestNew";
import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      enableConfirm: true,
      completeNotiBtnPressed: false,
      localForm: {
        des: "",
        dis: "",
        theme: "",
        life: "",
        type: ""
      },
      orgForm: {
        des: "",
        dis: "",
        theme: "",
        life: "",
        type: ""
      },
      dis: "",
      theme: "",
      life: "",
      type: ""
    };
  },
  // components: {
  //   WorkRequestNew
  // },
  watch: {
    // whenever question changes, this function will run
    type() {
      this.localForm.type = this.type;
      this.updateFormChar();
    },
    life() {
      this.localForm.life = this.life;
      this.updateFormChar();
    },
    theme() {
      this.localForm.theme = this.theme;
      this.updateFormChar();
    },
    dis() {
      this.localForm.dis = this.dis;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.type = this.getDetail.char.type;
    this.localForm.des = this.getDetail.char.des;
    this.localForm.dis = this.getDetail.char.dis;
    this.localForm.theme = this.getDetail.char.theme;
    this.localForm.life = this.getDetail.char.life;
    this.localForm.stat = this.getDetail.char.stat;

    this.orgForm.type = this.getDetail.char.type;
    this.orgForm.theme = this.getDetail.char.theme;
    this.orgForm.des = this.getDetail.char.des;
    this.orgForm.life = this.getDetail.char.life;
    this.orgForm.dis = this.getDetail.char.dis;
    this.orgForm.stat = this.getDetail.char.stat;
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    opsOptions,
    techOptions,
    announcements
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailStats",
      "getPreviousPage"
    ]),
    opsStatus() {
      let logic;
      if (this.getDetailChar.stat === true || this.completeNotiBtnPressed) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    opsArchived() {
      let logic;
      if (this.getDetailBasic.ver === "A") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    disableEdit() {
      let logic = null;
      if (
        this.getDetailChar.stat === true ||
        this.getPreviousPage === "/reportlist" ||
        this.getPreviousPage === "/reportdetaillist"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    confirmNotification() {
      let stats = this.getDetailStats;
      stats.nlike = stats.nlike + 1;
      // lock the button (one confirm at a time)
      this.enableConfirm = false;
      this.saveDocumentRevMod(4.11, 9); // business mod.
      this.$store.dispatch("changeDetailStats", stats);
      this.$store.dispatch("changeDataSavePendingIndication", true);
    },
    archiveOpsNotification() {
      this.completeNotiBtnPressed = true;
      this.localForm.stat = true;
      // MESSAGE
      let msg = "";
      msg = "Ops Noti complete process started.";
      this.generateInfoSnackbar(this.ui.colorWarning, msg);
    },
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.type !== this.orgForm.type &&
        this.localForm.type !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.type = this.localForm.type;
        // basic
        char.type = this.localForm.type;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.12, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.des !== this.orgForm.des &&
        this.localForm.des !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.des = this.localForm.des;
        // basic
        char.des = this.localForm.des;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.dis !== this.orgForm.dis &&
        this.localForm.dis !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.dis = this.localForm.dis;
        // basic
        char.dis = this.localForm.dis;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.type !== this.orgForm.type &&
        this.localForm.type !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.type = this.localForm.type;
        // basic
        char.type = this.localForm.type;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.theme !== this.orgForm.theme &&
        this.localForm.theme !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.theme = this.localForm.theme;
        // basic
        char.theme = this.localForm.theme;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        // this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.life !== this.orgForm.life &&
        this.localForm.life !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.life = this.localForm.life;
        // basic
        char.life = this.localForm.life;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
